// extracted by mini-css-extract-plugin
export default {"steps":"StepAdvisor_steps__HBEew","active":"StepAdvisor_active__wzm6Z"};